// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchangeListContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1px;
  width: 97%;
  height: 100dvh;
  padding: 10px;
  position: relative;
}
@media (min-width: 450px) {
  .exchangeListContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .exchangeListContainer {
    height: 100%;
  }
}
.exchangeListContainer .exchangeCard {
  display: flex;
  width: 100%;
  height: 84px;
  background-color: rgba(105, 155, 182, 0.3);
  border-radius: 10px;
  position: relative;
}
.exchangeListContainer .exchangeCard .deselectItem {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 10px;
  background-color: #699BB6;
}
.exchangeListContainer .exchangeCard .deselectItem .close, .exchangeListContainer .exchangeCard .deselectItem .confirm {
  background-size: cover;
  padding-left: 5px;
  padding-right: 5px;
  font-family: "Roboto", sans-serif;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 13px;
}
.exchangeListContainer .exchangeCard .diamondsToOffer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.exchangeListContainer .exchangeCard .inactiveExchange {
  display: flex;
  align-self: center;
}
.exchangeListContainer .exchangeCard .diamondsToRequest {
  display: flex;
  justify-content: center;
  align-items: center;
}
.exchangeListContainer .exchangeCard .selectedDiamondImg {
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.username {
  font-family: "Crimson Pro", serif;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  width: 100%;
  margin-bottom: 0px;
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/exchangesList/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EAIQ,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AAPR;AAPQ;EADR;IAEY,YAAA;EAUV;AACF;AARQ;EALR;IAMY,YAAA;EAWV;AACF;AADU;EACE,aAAA;EACA,WAAA;EACA,YAAA;EAGA,0CAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AAAY;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EAGA,mBAAA;EACA,yBCnCC;ADmCjB;AAEgB;EACI,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCErCX;EFsCW,cC3CP;ED4CO,gBAAA;EACA,eAAA;AAApB;AAIY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAFhB;AAIY;EAEI,aAAA;EACA,kBAAA;AAHhB;AAKY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAHhB;AAKY;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHhB;;AAOI;EACI,iCE1EM;EF2EN,cC7EK;ED8EL,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAJR","sourcesContent":["@import '../../../scss/colors.scss';\n@import '../../../scss/fonts.scss';\n\n.exchangeListContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        gap:1px;\n        width: 97%;\n        height: 100dvh;\n        padding: 10px;\n        position: relative;\n\n          .exchangeCard{\n            display: flex;\n            width: 100%;\n            height: 84px;\n            // background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n\n            background-color: rgba($color: $color-Secondary, $alpha: 0.3);\n            border-radius: 10px;\n            position: relative;\n            .deselectItem{\n                position: absolute;\n                right: 0;\n                top: 0;\n                // width: 20px;\n                // height: 20px;\n                border-radius: 10px;\n                background-color: $color-Secondary;\n\n                .close ,.confirm{\n                    background-size: cover;\n                    padding-left:5px ;\n                    padding-right:5px ;\n                    font-family: $Roboto;\n                    color: $color-White;\n                    font-weight: 600;\n                    font-size: 13px;\n                }\n                \n            }      \n            .diamondsToOffer{\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            }\n            .inactiveExchange{\n                // filter: brightness(0) saturate(100%) invert(59%) sepia(10%) saturate(1390%) hue-rotate(157deg) brightness(96%) contrast(87%);                \n                display: flex;\n                align-self:center;\n        }\n            .diamondsToRequest{\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            }\n            .selectedDiamondImg{\n                width: 60px;\n                height: 60px;\n                background-repeat: no-repeat;\n                background-position: center;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            }\n        }\n    }\n    .username{\n        font-family: $Crimson-Pro;\n        color: $color-White;\n        font-size: 20px;\n        font-weight: 500;\n        text-align: left;\n        width: 100%;\n        margin-bottom: 0px;\n        margin-left: 20px;\n    }","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
